'use client';
import React from 'react';

export default function Footer() {
  return (
    <footer className="main-footer">
      <div className="dentaire-container">
        <div className="row">
          {/* About Footer */}
          <div className="col-lg-4">
            <div className="about-footer">
              <div className="footer-logo">
                <img
                  src="/assets/images/logo-cosa-dark.png"
                  alt="COSA – Compagnie de Santé Africaine"
                  style={{ height: 56, width: 'auto', maxWidth: 180, objectFit: 'contain', display: 'block' }}
                />
              </div>
              <div className="about-footer-content">
                <p>COSA est un centre médical innovant offrant des soins de haute qualité accessibles à tous, avec un plateau technique de pointe pour élever les standards de santé en Côte d'Ivoire.</p>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-3 col-md-4">
            <div className="footer-links footer-quick-links">
              <h3>liens rapides</h3>
              <ul>
                <li><a href="#">accueil</a></li>
                <li><a href="#">à propos de nous</a></li>
                <li><a href="#">nos services</a></li>
                <li><a href="#">prendre rendez-vous</a></li>
              </ul>
            </div>
          </div>

          {/* Social Media */}
          <div className="col-lg-3 col-md-4">
            <div className="footer-links footer-social-links">
              <h3>réseaux sociaux</h3>
              <ul>
                <li><a href="#">facebook</a></li>
                <li><a href="#">instagram</a></li>
                <li><a href="#">youtube</a></li>
                <li><a href="#">twitter</a></li>
              </ul>
            </div>
          </div>

          {/* Contact */}
          <div className="col-lg-2 col-md-4">
            <div className="footer-links footer-contact-links">
              <h3>contact</h3>
              <ul>
                <li><a href="#">contact@cosa-sante.ci</a></li>
                <li><a href="#">+(225) 27 22 00 00 00</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-copyright">
          <div className="row">
            <div className="col-lg-12">
              <div className="footer-copyright-text">
                <p>Copyright &copy; 2025 COSA — Compagnie de Santé Africaine. Tous droits réservés.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>);

}